import { render, staticRenderFns } from "./ReportingBODACCPage.vue?vue&type=template&id=2a24e72e&"
import script from "./ReportingBODACCPage.vue?vue&type=script&lang=js&"
export * from "./ReportingBODACCPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportingBODACCPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports